class RosviaCatalog {
  constructor(root) {
    this.root = root;
    this.layout = root.querySelector('[data-catalog-layout]');
    this.panel = root.querySelector('[data-filter-panel]');
    this.form = root.querySelector('[data-facet-form]');
    this.mobile = matchMedia('(max-width: 767px)');
    this.onKeydown = (e) => { if (e.key === 'Escape' && this.panel?.classList.contains('is-open')) this.closePanel(); };
    this.syncPanel = this.syncPanel.bind(this);
    this.mobile.addEventListener('change', this.syncPanel);
    document.addEventListener('keydown', this.onKeydown);
    this.syncPanel();
    let view = 'grid';
    try { view = localStorage.getItem('rosvia:catalog-view') || view; } catch {}
    this.setView(view);
    root.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-filters-toggle]');
      if (toggle && this.panel) {
        if (this.mobile.matches) this.openPanel();
        else this.setToggles(!this.layout.classList.toggle('is-collapsed'));
      }
      if (e.target.closest('[data-filters-close]')) this.closePanel();
      const viewButton = e.target.closest('[data-view]');
      if (viewButton) this.setView(viewButton.dataset.view);
      const more = e.target.closest('[data-load-more]');
      if (more) { e.preventDefault(); this.loadMore(more); }
    });
    document.body.addEventListener('click', (e) => { if (document.body.classList.contains('filters-open') && e.target === document.body) this.closePanel(); });
    root.querySelector('[data-sort]')?.addEventListener('change', () => this.form.requestSubmit());
    this.form?.addEventListener('change', (e) => { if (e.target.matches('[data-facet-auto]')) this.form.requestSubmit(); });
    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const url = new URL(this.form.action, location.href);
      const data = new FormData(this.form);
      root.querySelectorAll(`[form="${this.form.id}"]`).forEach((field) => { if (field.name && !data.has(field.name)) data.append(field.name, field.value); });
      url.search = new URLSearchParams([...data].filter(([, value]) => value !== '')).toString();
      location.assign(url);
    });
    root.querySelectorAll('[data-price-range]').forEach((group) => this.initPrice(group));
  }
  initPrice(group) {
    const low = group.querySelector('[data-range-min]'), high = group.querySelector('[data-range-max]');
    const min = group.querySelector('[data-price-min]'), max = group.querySelector('[data-price-max]');
    const fill = group.querySelector('[data-price-fill]');
    const minLabel = group.querySelector('[data-price-min-label]'), maxLabel = group.querySelector('[data-price-max-label]');
    const limit = Number(high.max) || 0, currency = group.dataset.currency || '';
    const update = (moved) => {
      let lower = Number(low.value), upper = Number(high.value);
      if (lower > upper) { if (moved === low) { upper = lower; high.value = upper; } else { lower = upper; low.value = lower; } }
      min.value = lower > 0 ? String(lower) : '';
      max.value = upper < limit ? String(upper) : '';
      minLabel.textContent = `${currency}${lower}`;
      maxLabel.textContent = `${currency}${upper}`;
      if (limit > 0) { fill.style.left = `${(lower / limit) * 100}%`; fill.style.right = `${100 - (upper / limit) * 100}%`; }
    };
    group.addEventListener('input', (e) => { if (e.target === low || e.target === high) update(e.target); });
    update();
  }
  openPanel() {
    this.panel.classList.add('is-open');
    document.body.classList.add('filters-open');
    this.setToggles(true);
    this.panel.querySelector('[data-filters-close]')?.focus();
  }
  closePanel() {
    if (!this.panel?.classList.contains('is-open')) return;
    this.panel.classList.remove('is-open');
    document.body.classList.remove('filters-open');
    this.setToggles(false);
    this.root.querySelector('[data-filters-toggle]')?.focus();
  }
  syncPanel() {
    if (!this.panel) return;
    this.panel.classList.remove('is-open');
    document.body.classList.remove('filters-open');
    if (this.mobile.matches) this.setToggles(false);
    else this.setToggles(!this.layout.classList.contains('is-collapsed'));
  }
  setToggles(expanded) {
    this.root.querySelectorAll('[data-filters-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(expanded)));
  }
  setView(view) {
    view = view === 'list' ? 'list' : 'grid';
    const products = this.root.querySelector('[data-products]');
    if (products) products.dataset.viewMode = view;
    this.root.querySelectorAll('[data-view]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
    try { localStorage.setItem('rosvia:catalog-view', view); } catch {}
  }
  async loadMore(button) {
    if (this.loading) return;
    this.loading = true;
    button.setAttribute('aria-disabled', 'true'); button.setAttribute('aria-busy', 'true');
    const error = this.root.querySelector('[data-catalog-error]'); error.hidden = true;
    try {
      const url = new URL(button.href); url.searchParams.set('section_id', this.root.dataset.sectionId);
      const response = await fetch(url); if (!response.ok) throw new Error();
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-products]'); if (!next) throw new Error();
      const products = this.root.querySelector('[data-products]');
      const existing = new Set([...products.children].map((el) => el.dataset.resultId));
      const added = [...next.children].filter((el) => !existing.has(el.dataset.resultId));
      products.append(...added);
      this.root.querySelector('[data-pagination]').innerHTML = doc.querySelector('[data-pagination]')?.innerHTML || '';
      document.dispatchEvent(new CustomEvent('products:rendered'));
      const focus = added[0]?.querySelector('a'); focus?.focus({ preventScroll: true });
    } catch { error.textContent = this.root.dataset.loadError; error.hidden = false; }
    finally { this.loading = false; button.removeAttribute('aria-disabled'); button.removeAttribute('aria-busy'); }
  }
  destroy() {
    this.mobile.removeEventListener('change', this.syncPanel);
    document.removeEventListener('keydown', this.onKeydown);
    document.body.classList.remove('filters-open');
  }
}
function initCatalog(scope = document) { scope.querySelectorAll('[data-catalog]').forEach((root) => { if (!root.catalogController) root.catalogController = new RosviaCatalog(root); }); }
initCatalog();
document.addEventListener('shopify:section:load', (e) => initCatalog(e.target));
document.addEventListener('shopify:section:unload', (e) => e.target.querySelectorAll('[data-catalog]').forEach((root) => root.catalogController?.destroy()));
